// extracted by mini-css-extract-plugin
export default {"cls1":"UUbChQY4ejnHlLriiGfv","cls2":"vYjoyH7E6rju018Fkhim UUbChQY4ejnHlLriiGfv"};